<script>
  import solicitacaoAdiantamentoServico from '../servico';
  import Cabecalho from '~componentes/CabecalhoRelatorio.vue';
  import Barcode from '@xkeshi/vue-barcode';
  import tiposConta from '~js/tipos-conta';
  import tiposPix from '~js/tipos-pix';
  import formasPagamento from '~js/formas-pagamento';
  import ListaDespesasRubricas from './compartilhado/FormListaDespesasRubricas.vue';
  import converterMoeda from '~js/converter-moeda';
  import ListaRateioDespesasRubricas from './compartilhado/ListaRateioDespesasRubricas.vue';
  
  export default {
    components: { Cabecalho, Barcode, ListaDespesasRubricas, alert, ListaRateioDespesasRubricas },
    data() {
      return {
        solicitacao: {},
        carregando: true,
        tiposConta: tiposConta,
        tiposPix: tiposPix,
        formasPagamento: formasPagamento,
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      carregar: function(id) {
        this.carregando = true;

        solicitacaoAdiantamentoServico
          .obterPorId(id)
          .then(solicitacao => {
            this.carregando = false;
            this.solicitacao = solicitacao;
          });
      },
      tipoConta(id) {
        return this.tiposConta.find(t => {
          return t.id === id;
        });
      },
      tipoPix(id) {
        return this.tiposPix.find(t => {
          return t.id === id;
        });
      },
      formaPagamento(id) {
        return this.formasPagamento.find(f => {
          return f.id === id;
        });
      },
    },
    computed: {
      periodoDeVigencia() {
        let dataInicio = this.solicitacao.projeto.dataInicioVigencia;
        let dataTermino = this.solicitacao.projeto.dataTerminoVigencia;

        if (dataInicio === 0 && dataTermino === 0) {
          return '---';
        }

        let periodo = this.$options.filters.formatarNumeroEmData(dataInicio);

        if (dataTermino) {
          periodo += ` - ${this.$options.filters.formatarNumeroEmData(dataTermino)}`;
        }

        return periodo;
      },
      dataLiberacaoCoordenador() {
        return this.$options.filters.formatarNumeroEmDataExtenso(this.solicitacao.liberacaoCoordenador) || '---';
      },
      totalSolicitado() {
        return this.solicitacao.despesasViajem.reduce((total, despesa) => {
          return total + converterMoeda.paraDolar(despesa.valorSolicitado);
        }, 0);
      },
      totalDeclarado() {
        let total = 0;

        this.solicitacao.despesasViajem.map(despesa => {
          total += despesa.rateios.reduce((somatorio, rateio) => {
            return somatorio + converterMoeda.paraDolar(rateio.valor);
          }, 0);
        });

        return total;
      },
      totalAprovado() {
        let total = 0;

        this.solicitacao.despesasViajem.map(despesa => {
          total += despesa.rateios.reduce((somatorio, rateio) => {
            return somatorio + rateio.valorValidado;
          }, 0);
        });

        return total;
      },
      permitirDeclaracao() {
        let permitir = true;

        this.solicitacao.despesasViajem.map(despesa => {
          despesa.rateios.map(rateio => {
            if (rateio.validade === 1) {
              permitir = false;
            }
          });
        });

        return permitir;
      },
    },
    created() {
      this.carregar(this.$route.params.id);
    },
    mounted() {
      this.$root.tituloDaPagina = 'Solicitação de Adiantamento - Relatório';
      this.$root.botaoAcaoTexto = 'Imprimir relatório';
      this.$root.botaoAcaoIcon = 'fa-print';
      this.$root.botaoAcaoLink = '';
      this.$root.filtrosBag = this.$route.params.filtrosBag;

      this.$root.botaoRetrocederMostrar = true;

      if (this.$route.params.rota)
        this.$root.botaoRetrocederRota = this.$route.params.rota
      else
        this.$root.botaoRetrocederRota = 'solicitacao-adiantamento';

      this.$events.on('botaoAcao', function() {
        window.print();
      });
    },
    beforeDestroy() {
      this.$events.off('botaoAcao');
    }
  }
</script>

<template>
  <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao" id="relatorio">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">

            <p v-show="carregando" class="text-center">
              <i class='fa fa-spinner fa-pulse'></i> Carregando...
            </p>

            <div v-if="!carregando">
              <cabecalho :titulo="'Solicitação de Adiantamento'"></cabecalho>

              <h3 class="m-t-none m-b">Dados da solicitação</h3>

              <div class="hr-line-dashed margin-top-5"></div>

              <div class="row">
                <dl class="col-xs-8">
                  <dt>Projeto</dt>
                  <dd>{{ solicitacao.projeto ? solicitacao.projeto.nomeProjeto : '' }}</dd>
                </dl>
                <dl class="col-xs-4">
                  <dt>Tipo de projeto</dt>
                  <dd>{{ solicitacao.projeto.tipoProjeto ? solicitacao.projeto.tipoProjeto.nome : '---' }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-6">
                  <dt>Período de vigência</dt>
                  <dd>{{ periodoDeVigencia }}</dd>
                </dl>
                <dl class="col-xs-6">
                  <dt>Nr. processo</dt>
                  <dd>{{ solicitacao.projeto ? solicitacao.projeto.nrProcesso : '---' }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-4">
                  <dt>Número</dt>
                  <dd>{{ solicitacao.idSolicitacaoAdiantamento || '---' }}</dd>
                </dl>

                <dl class="col-xs-4">
                  <dt>Data da solicitação</dt>
                  <dd>{{ solicitacao.dataSolicitacao | formatarNumeroEmDataExtenso }}</dd>
                </dl>

                <dl class="col-xs-4">
                  <dt>Coordenador do projeto</dt>
                  <dd>{{ solicitacao.projeto.coordenador ? solicitacao.projeto.coordenador.nomePessoaFisicaJuridica : '---' }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl :class="[configuracao.criarProtocoloSolicitacao ? 'col-xs-3' : 'col-xs-6']">
                  <dt>Data de liberação do coordenador</dt>
                  <dd>{{ dataLiberacaoCoordenador }}</dd>
                </dl>

                <dl :class="[configuracao.criarProtocoloSolicitacao ? 'col-xs-3' : 'col-xs-6']">
                  <dt>Liberado por</dt>
                  <dd>{{ solicitacao.liberadoPor ? solicitacao.liberadoPor.nomePessoaFisicaJuridica : '---' }}</dd>
                </dl>

                <dl class="col-xs-3" v-if="configuracao.criarProtocoloSolicitacao && solicitacao.protocolo != null">
                  <dt>Nº protocolo</dt>
                  <dd>{{ solicitacao.protocolo ? solicitacao.protocolo.numeroProtocolo : '---' }}</dd>
                </dl>

                <dl class="col-xs-3" v-if="configuracao.criarProtocoloSolicitacao && solicitacao.protocolo != null">
                  <dt>Código de barras protocolo</dt>
                  <dd><barcode :value="solicitacao.protocolo.numeroProtocolo" :options="{ displayValue: false, height: 20, margin: 1 }"></barcode></dd>
                </dl>
              </div>

              <h3 class="m-t-none m-b">Tipo</h3>

              <div class="hr-line-dashed margin-top-5"></div>

              <div class="row">
                <dl class="col-xs-12">
                  {{ solicitacao.adiantamentoViagem == 1 ? 'Adiantamento de viagens' : 'Adiantamento de suprimento de fundos' }}
                </dl>
              </div>

              <h3 class="m-t-none m-b">Dados cadastrais</h3>

              <div class="hr-line-dashed margin-top-5"></div>

              <div class="row">
                <dl class="col-xs-6">
                  <dt>Nome</dt>
                  <dd>{{ solicitacao.nomeRequerinte || '---' }}</dd>
                </dl>

                <dl class="col-xs-4">
                  <dt>{{ solicitacao.cpf.length === 14  ? 'CPF' : 'CNPJ' }}</dt>
                  <dd>{{ solicitacao.cpf || '---' }}</dd>
                </dl>

                <dl class="col-xs-2" v-if="solicitacao.cpf.length === 14">
                  <dt>Data de nascimento</dt>
                  <dd>{{ solicitacao.dataNascimento | formatarNumeroEmData('---') }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-6">
                  <dt>Endereço</dt>
                  <dd>{{ solicitacao.endereco || '---' }}</dd>
                </dl>

                <dl class="col-xs-3">
                  <dt>Número</dt>
                  <dd>{{ solicitacao.numero || '---' }}</dd>
                </dl>

                <dl class="col-xs-3">
                  <dt>Complemento</dt>
                  <dd>{{ solicitacao.complemento || '---' }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-4">
                  <dt>Bairro</dt>
                  <dd>{{ solicitacao.bairro || '---' }}</dd>
                </dl>

                <dl class="col-xs-4">
                  <dt>Cidade</dt>
                  <dd>{{ solicitacao.cidade || '---' }}</dd>
                </dl>

                <dl class="col-xs-4">
                  <dt>Estado</dt>
                  <dd>{{ solicitacao.uf || '---' }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-4">
                  <dt>Telefone</dt>
                  <dd>{{ solicitacao.telefone || '---' }}</dd>
                </dl>

                <dl class="col-xs-4">
                  <dt>Celular</dt>
                  <dd>{{ solicitacao.celular || '---' }}</dd>
                </dl>

                <dl class="col-xs-4">
                  <dt>E-mail do beneficiário</dt>
                  <dd>{{ solicitacao.email || '---' }}</dd>
                </dl>
              </div>

              <h3 class="m-t-none m-b">Dados para o pagamento</h3>

              <div class="hr-line-dashed margin-top-5"></div>

              <div class="row">
                <dl class="col-lg-6" v-if="configuracao.exibirDataPgtoSolicitacaoPgto">
                  <dt>Data para pagamento</dt>
                  <dd>{{ solicitacao.dataPagamento || '---' }}</dd>
                </dl>

                <dl :class="[configuracao.exibirDataPgtoSolicitacaoPgto ? 'col-lg-6' : 'col-lg-12']">
                  <dt>Forma de pagamento</dt>
                  <dd>{{ formaPagamento(solicitacao.formaPagamento).nome }}</dd>
                </dl>
              </div>

              <div v-if="solicitacao.formaPagamento === 0">
                <h3 class="m-t-none m-b">Dados bancários</h3>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row" v-if="solicitacao.tipoConta != 4">
                  <dl class="col-xs-3">
                    <dt>Banco</dt>
                    <dd>{{ solicitacao.banco || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Agência</dt>
                    <dd>{{ solicitacao.agencia || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Conta</dt>
                    <dd>{{ solicitacao.conta || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Tipo de conta</dt>
                    <dd>{{ tipoConta(solicitacao.tipoConta).nome }}</dd>
                  </dl>
                </div>

                <div class="row" v-if="solicitacao.tipoConta == 4">
                  <dl class="col-xs-3">
                    <dt>Tipo pix</dt>
                    <dd>{{ tipoPix(solicitacao.tipoPix).nome }}</dd>
                  </dl>

                  <dl class="col-xs-9">
                    <dt>Chave PIX</dt>
                    <dd>{{ solicitacao.chavePix || '---' }}</dd>
                  </dl>
                </div>
              </div>

              <div v-if="solicitacao.adiantamentoViagem === 1">
                <h3 class="m-t-none m-b">Dados da viagem</h3>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-4">
                    <dt>Localidade</dt>
                    <dd>{{ solicitacao.localidade || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-4">
                    <dt>Partida</dt>
                    <dd>{{ solicitacao.dataPartida || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-4">
                    <dt>Retorno</dt>
                    <dd>{{ solicitacao.dataRetorno || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-12">
                    <dt>Finalidade da viagem</dt>
                    <dd class="white-space-pre">{{ solicitacao.finalidadeViagem || '---' }}</dd>
                  </dl>
                </div>
              </div>

              <h3 class="m-t-none m-b">Despesas com rubricas</h3>

              <div class="hr-line-dashed margin-top-5"></div>

              <div>
                <div class="bs-callout bs-callout-info no-margin-top" v-for="(despesa, index) in solicitacao.despesasViajem">

                  <h4>
                    Item #{{ index + 1 }}
                  </h4>

                  <div class="row">
                    <dl class="col-md-4">
                      <dt>Rubrica</dt>
                      <dd>{{ despesa.rubrica ? despesa.rubrica.nome : '---' }}</dd>
                    </dl>
                    <dl class="col-md-4">
                      <dt>Subrubrica</dt>
                      <dd>{{ despesa.subrubrica ? despesa.subrubrica.nome : '---' }}</dd>
                    </dl>
                    <dl class="col-md-4">
                      <dt>Valor</dt>
                      <dd>{{ despesa.valorSolicitado || '---' }}</dd>
                    </dl>
                  </div>

                  <div class="row" v-if="despesa.observacao">
                    <dl class="col-md-12">
                      <dt>Observação</dt>
                      <dd>{{ despesa.observacao || '---' }}</dd>
                    </dl>
                  </div>

                  <lista-rateio-despesas-rubricas :rateios="despesa.rateios"
                                                  :relatorio="true"
                                                  :declaracaoIniciada="!permitirDeclaracao">
                  </lista-rateio-despesas-rubricas>

                </div>
              </div>

              <h3 class="m-t-none m-b">Declaração de despesas</h3>

              <div class="hr-line-dashed margin-top-5"></div>

              <div class="row">
                <dl class="col-md-4">
                  <dt class="text-right">Total solicitado</dt>
                  <dd class="text-right">{{ totalSolicitado | formatarNumero }}</dd>
                </dl>

                <dl class="col-md-4">
                  <dt class="text-right">Total de despesas declaradas</dt>
                  <dd class="text-right">{{ totalDeclarado | formatarNumero }}</dd>
                </dl>

                <dl class="col-md-4">
                  <dt class="text-right">Diferença</dt>
                  <dd class="text-right">{{ (totalSolicitado - totalDeclarado) | formatarNumero }}</dd>
                </dl>
              </div>

              <h3 class="m-t-none m-b">Aprovação pela fundação</h3>

              <div class="hr-line-dashed margin-top-5"></div>

              <div class="row">
                <dl class="col-md-4">
                  <dt class="text-right">Total solicitado</dt>
                  <dd class="text-right">{{ totalSolicitado | formatarNumero }}</dd>
                </dl>

                <dl class="col-md-4">
                  <dt class="text-right">Total de despesas aprovadas</dt>
                  <dd class="text-right">{{ totalAprovado | formatarNumero }}</dd>
                </dl>

                <dl class="col-md-4">
                  <dt class="text-right">Diferença</dt>
                  <dd class="text-right">{{ (totalSolicitado - totalAprovado) | formatarNumero }}</dd>
                </dl>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <p class="text-danger small"><i>* Enquanto despesa aprovada for igual a zero, significa que a fundação ainda não analisou a prestação.</i></p>
                </div>
              </div>

              <div class="hr-line-dashed margin-top-5" v-if="this.configuracao.solAdiantamentoMsgConfirmacao"></div>

              <div class="row" v-if="this.configuracao.solAdiantamentoMsgConfirmacao">
                <div class="col-md-12">
                  <p><i>{{this.configuracao.solAdiantamentoMsgConfirmacao}}</i></p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-adiantamento/componentes/SolicitacaoAdiantamentoRelatorio.vue